import { useEffect } from "react";

const LiveChat = () => {
    useEffect(() => {
        setTimeout(function () {
            window.initialiseLiveChat();
        }, 5000);
    });

    return (
        <div id="divicw" data-bind={process.env.NEXT_PUBLIC_LIVE_CHAT_DATA_BIND_ID} data-org="" />
    );
};

export default LiveChat;
